import styled from 'styled-components';

export const StyledErrorMessage = styled.div`
  ${({ theme }) => theme.mixins.Container('ROW', { alignItems: 'center' })}
  background-color: ${({ theme }) => theme.values.colors.background.caution.BASE};
  padding: ${({ theme }) => theme.values.spacing.MEDIUM};
  color: ${({ theme }) => theme.values.colors.text.ACCENT};
  border-color: ${({ theme }) => theme.values.colors.stroke.caution.BASE};
  border-radius: ${({ theme }) => theme.values.radii.MEDIUM};
  border-width: ${({ theme }) => theme.values.strokeWidths.MEDIUM};
  border-style: solid;
  position: fixed;
  top: 8rem;
  left: ${({ theme }) => theme.values.spacing.MEDIUM};
  right: ${({ theme }) => theme.values.spacing.MEDIUM};
  max-width: 40rem;
  margin: 0 auto;
`;

export const StyledErrorText = styled.div`
  flex: 1;
  font-weight: ${({ theme }) => theme.values.fontWeights.MEDIUM};
`;

export const StyledCloseIcon = styled.div`
  height: ${({ theme }) => theme.values.iconSizes.MEDIUM};
  width: ${({ theme }) => theme.values.iconSizes.MEDIUM};
  color: ${({ theme }) => theme.values.colors.text.ACCENT};
`;
